import React from 'react';
import PropTypes from 'prop-types';

import './Button.scss';

export const Button = ({className, onClick, children}) =>
  <button onClick={onClick} className={`button ${className}`}>{children}</button>;

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  onClick: PropTypes.func,
};

Button.defaultProps = {
  className: '',
  onClick: null,
  children: 'Click me'
};

export default Button;


// WEBPACK FOOTER //
// ./src/components/Button/Button.jsx